<template>
  <body class="layout-row">
    <div id="main" class="layout-column flex">
    <!--  <div id="header" class="page-header fixed-top" >
        <div class="navbar navbar-expand-sm">
          
            <div class="collapse navbar-collapse order-2 order-lg-1" id="navbarToggler">
             
                <div class="nav-item d-none nav-link d-flex align-items-center px-2 text-color">
                     
                    Welcome&nbsp;<strong class="text-primary">{{getUser.username}}</strong>
                
                </div>
            </div>
            <ul class="nav navbar-menu order-1 order-lg-2">
              <li class="nav-item">
                  <button  @click="openpassword();" id="btnchangepass" class="btn btn-primary ml-4 mb-2">Change Password</button>
              </li>

                <li class="nav-item">
                  <button  @click="claimrebate();" id="btnclaimrebate" class="btn btn-primary ml-4 mb-2">Claim Rebate</button>
                </li>

              <li class="nav-item" style="padding-left:10px;">
                  <span >Rebate : </span><span id="rebateval">{{getUser.rebate_value}}</span>
                </li>
               
              
                <li class="nav-item">
                  
                    <router-link  href="#" to="/signout"  class="nav-link d-flex align-items-center px-2 text-color">
                        <span>Log Out</span>
                    </router-link>
                </li>

            </ul>
        </div>
      </div>  -->


        <div id="header" >
        <b-navbar toggleable="lg" type="dark" variant="dark">
          <b-navbar-brand href="#">
            Welcome&nbsp;<strong class="text-primary">{{getUser.username}}</strong>
          </b-navbar-brand>
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
              <b-nav-item><b-button size="sm" class="my-2 my-sm-0" t @click="openpassword();" >Change Password</b-button></b-nav-item>
              <b-nav-form>
               

                <b-form-input size="sm" readonly class="mr-sm-2 form-control-plaintext" :value="'Rebate : '+getUser.rebate_value"></b-form-input>
                <b-button size="sm" class="my-2 my-sm-0" @click="claimrebate();" id="btnclaimrebate" >Claim Rebate</b-button>
              </b-nav-form>

              <router-link  href="#" to="/signout"  class="nav-link d-flex align-items-center px-2 text-color">
                  <b-button size="sm" class="my-2 my-sm-0" id="btnoutplay">Log Out</b-button>
              </router-link>


            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>


      <div id="content" class="flex ">
        <iframe :src="getUser.login_url" frameborder="0" class="playiFrame"></iframe>
      </div>

      <div class="mb-2" style="display:none;">
     <b-button @click="showMsgBoxOne">Simple msgBoxConfirm</b-button>
     Return value: {{ String(boxOne) }}
</div>

    </div>

     <div ref="mod-changepass" id="mod-changepass" class="modal fade" data-backdrop="true">
      <div class="modal-dialog" >
        <div class="modal-content h-50 no-radius bg-dark">
          <div class="modal-header ">
            <div class="modal-title text-md row" style="padding-left:20px;">Change Password</div>
            
            <button class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <div class="p-3 row">

              <div class="col col-12">
                <div class="card">

                  <div class="card-body">
                  <input type="hidden" name="pass_userid" id="pass_userid" value=""/>
                  <div class="form-group">
                      <label for="deposit credit">Current Password</label>
                      <input v-model="current_pass"  type="password" class="form-control" placeholder="New Password" id="current_pass">
                  </div>

                  <div class="form-group">
                      <label for="deposit credit">New Password</label>
                      <input v-model="new_pass"  type="password" class="form-control" placeholder="New Password" id="change_new_pass">
                  </div>

                  <div class="form-group">
                      <label for="deposit credit">New Password Confirmation</label>
                      <input v-model="confirm_new_pass"  type="password" class="form-control" placeholder="Confirm New Password" id="change_new_pass_confirmation">
                  </div>

                  </div>
                </div>
              </div>
             

          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" @click="closepass()">Cancel</button>
          <button  @click="savechangepass(current_pass,new_pass,confirm_new_pass)" type="button" class="btn btn-primary">Post</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
  </div>


   <div class="col-lg-2">
    <div class="modal fade" id="mb-load" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog" style="width:90%;">
            <div class="modal-content">
                
                   <div align="center">
            <div class="loader" id="loaderDiv" ></div>
            </div>
           
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
    </div>
    <!-- /.col-lg-12 -->
</div>
  </body>
</template>

<script>
import { mapGetters } from "vuex";
import * as TYPES from "@/store/mutation-types";
import { SIGNOUT,LOGOUT } from '@/store/mutation-types'


export default {
  name: 'PagePlay',
  computed: {
    ...mapGetters(["singlePlayer"]),
    getUser() {
     // console.log("DataPlayer")
      //console.log(this.singlePlayer)
      return this.singlePlayer
    }
  },
 
  methods: {
  leaving() {

    this.$store.commit(SIGNOUT)
    this.$store.commit(LOGOUT)


    

    /*  debugger;
      if(window.opener.title == undefined){
          isRefresh = true;
          document.write('Window was refreshed!');
      } else {
       this.$store.commit(SIGNOUT)
       this.$store.commit(LOGOUT)
      }*/

    /*  this.$http.get('sexymm/logout').then(
        this.signout, this.signout  
       
      );*/
        // debugger; 
    },
    signout () {
      this.$store.commit(SIGNOUT)
       this.$store.commit(LOGOUT)
      window.location.replace('/#/play');
    },
    claimrebate(){
        this.boxOne = ''
        this.$bvModal.msgBoxConfirm('Are you sure want to claim your rebate ?')
          .then(value => {
            this.boxOne = value
               // do unlock
         if (value == true){
          $("#mb-load").modal();
            this.$store.dispatch(TYPES.CLAIM_REBATE).then(res => {
           // debugger;
              if(res.status == 1){
                $("#mb-load").modal('hide');
                this.$bvToast.toast(`Rebate claimed successfully...`, {
                title: `Data Saved `,
                variant: 'info',
                toaster: 'b-toaster-top-center',
                solid: true
              })
            document.getElementById("rebateval").innerHTML = "0";
          } else {
         //   debugger;
            this.$bvToast.toast(res.message, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
          }
            });
         }
         })
          .catch(err => {
            // An error occurred
          })
    },
    openpassword(){
        $('#mod-changepass').modal();
    },
    closepass(){
       $('#mod-changepass').modal('hide');
    },
    savechangepass(mycurrent_pass,mynew_password,myconfirm_new_password){
       let defuser = this.getUser
        var theid = defuser.user_id;

        if (mynew_password != '' && myconfirm_new_password != ''){
           if (mynew_password == myconfirm_new_password){
            $("#mb-load").modal();
              let agent = {
                user_id : theid,
                password : mynew_password
              };
              let cekus = {
                email : defuser.username,
                password : mycurrent_pass
              }
              this.$http.post('sexymm/login', cekus)
          .then(({ data }) => {
                  //  console.log("Hello")
                    this.$store.dispatch(TYPES.CHANGE_PASSWORD, agent).then(res => {
                 // debugger;
                 if(res.status == 200){
            $("#mb-load").modal('hide');
            this.$bvToast.toast(`You password has been changed successfully...`, {
              title: `Password Changed `,
              variant: 'info',
              toaster: 'b-toaster-top-center',
              solid: true
            })
            $('#change_new_pass_confirmation').val('');
            $('#change_new_pass').val('');
            $('#current_pass').val('');
            $('#mod-changepass').modal('hide');
            this.new_pass = "";
            this.confirm_new_pass = "";
            this.current_pass = "";
          }
              });
        }, ({ data }) => {
           $("#mb-load").modal('hide');
          this.$bvToast.toast(`Wrong Current Password`, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            });
        })

        
           } else {
              this.$bvToast.toast(`Unmatch Password and Password confirmation `, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            });
           } 
         } else {
              this.$bvToast.toast(`Please input password and password confirmation`, {
              title: `Data Error `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
           })
        }
    }
  },
  created: function(){
    if(!this.$store.state.playerToken){
      window.location.replace('/#/play');
    }
     window.addEventListener('beforeunload', this.leaving)
   //  window.addEventListener('onunload', this.leaving)
  },
  onIdle() {
    //alert("Idle niii")
    this.$store.commit(SIGNOUT)
       this.$store.commit(LOGOUT)
      window.location.replace('/#/play');
  },

}

</script>